import { styled } from '@lichtblick/styled';
import { Spacing } from '@lichtblick/theme';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.Xxs};
`;
